import { ILocale } from '../models'

export const getTranslationParts = (
  locale: ILocale
): { languageCode: string; countryCode: string } => {
  const valueArr = locale.value.replace(/\s/g, '').split('-')
  return { languageCode: valueArr[0], countryCode: valueArr[1] || '' }
}
